import React from 'react';
import { BOT_CREATE_TYPE, CreateBotFormValues } from './form-helpers';
import { Label } from 'reactstrap';
import { FormikProps } from 'formik';
import classnames from 'classnames';
import ProRibbon from '../../components/ProRibbon/ProRibbon';

type Props = {
  labelText: string;
  formProps: FormikProps<CreateBotFormValues>;
  botCreateType: BOT_CREATE_TYPE;
  requiresPro: boolean;
};

const CreateBotTypeInput = (props: Props) => {
  const { labelText, formProps, botCreateType, requiresPro } = props;

  const templateTextClass = classnames('create-chatbot-modal__type-text', {
    'create-chatbot-modal__type-text--active':
      formProps.values.createType === botCreateType,
  });

  return (
    <Label className="create-chatbot-modal__type-label" check>
      <input
        type="radio"
        className="create-chatbot-modal__type-selector"
        name="createType"
        value={botCreateType}
        onChange={formProps.handleChange}
        onBlur={formProps.handleBlur}
        checked={formProps.values.createType === botCreateType}
      />

      <span className={templateTextClass}>{labelText}</span>

      {requiresPro && (
        <ProRibbon
          ribbonType="pro"
          className="create-chatbot-modal__pro-icon"
        />
      )}
    </Label>
  );
};

export default CreateBotTypeInput;
